module.exports = __webpack_public_path__ + "static/media/banner-trophy.9187930b.svg";